import styled from 'styled-components';

export const Container = styled.aside`
  background-color: #263238;
  width: 250px;
  height: 100%;
  position: fixed;
  margin-top: 66px;

  @media (max-width: 991px) {
    display: none;
    width: 100%;
    z-index: 2;

    &.active {
      display: block;
    }
  }

  .sidebar-brand {
    display: block;
    background-color: #398bfa;
    color: #fff;
    padding: 0 22px;
    height: 66px;
    font-weight: bold;
    font-size: 18px;
    line-height: 66px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

    &:hover,
    &:focus,
    &:active {
      color: #fff;
      text-decoration: none;
    }
  }
`;

export const Menu = styled.ul`
  margin-top: 20px;

  a {
    display: block;
    color: #a3afb7;
    padding: 9px 22px;
    font-size: 14px;
    text-decoration: none;
    transition: 0.3s all;

    &:hover {
      background-color: #2a363c;
      color: #fff;
    }

    .item-icon {
      width: 20px;
      display: inline-block;
      text-align: center;
      margin-right: 14px;
    }
  }
`;

export const MenuIcon = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: none;
  left: 20px;
  position: fixed;
  top: 20px;
  width: 40px;
  z-index: 1;

  @media (max-width: 991px) {
    display: block;
  }

  &:focus {
    outline: 0;
  }

  .bar {
    height: 5px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 7px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Sidebar/styles.js